import { useState } from "react";
import { caseStudies } from "./case-study/types";
import CaseStudyAccordionView from "./case-study/CaseStudyAccordionView";
const CaseStudy = () => {
  const [activeTab, setActiveTab] = useState<string>("ux-design");
  return <section id="case-study" className="section bg-grayLight py-16 md:py-20 w-full">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="section-header text-center mb-8 md:mb-12">
          <span className="inline-block px-4 py-1.5 bg-cyanPrimary/10 text-cyanPrimary rounded-full text-sm font-medium mb-4">
            Featured Work
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-darkText mb-4">
            📊 Case <span className="text-cyanPrimary">Studies</span>
          </h2>
          <p className="text-grayText max-w-2xl mx-auto text-base md:text-lg">See how I've helped teams uncover real user needs, shape product strategy, and build MVPs that matter.</p>
        </div>
      </div>

      {/* Full-width Accordion View */}
      <CaseStudyAccordionView caseStudies={caseStudies} activeTab={activeTab} setActiveTab={setActiveTab} />
    </section>;
};
export default CaseStudy;